import script from "./imported-payroll-history-report.vue?vue&type=script&setup=true&lang=js"
export * from "./imported-payroll-history-report.vue?vue&type=script&setup=true&lang=js"

import "./imported-payroll-history-report.vue?vue&type=style&index=0&id=2dd6c33a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd6c33a"]])

export default __exports__